module.exports = __webpack_public_path__ + "img/bg.8ea497e7.jpg";